import AnnouncementBar from './AnnouncementBar';

export default AnnouncementBar;
